import React from 'react';
import { Form, Button, Alert, Spinner, InputGroup } from 'react-bootstrap';
import { Mail, ArrowRight } from 'lucide-react';
import { triggerMediumHaptic } from '../../utils/haptics';

const OtpLoginForm = ({
  identifier,
  setIdentifier,
  otp,
  setOtp,
  otpSent,
  setOtpSent,
  handleRequestOtp,
  handleOtpLogin,
  message,
  loading
}) => {
  return (
    <>
      {message.text && (
        <Alert variant={message.type === 'danger' ? 'danger' : 'info'} className="py-2 small">
          {message.text}
        </Alert>
      )}

      {!otpSent ? (
        <Form onSubmit={handleRequestOtp}>
          <Form.Group className="mb-4">
            <InputGroup className="login-input-group">
              <InputGroup.Text><Mail size={18}/></InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Enter registered Email or Mobile"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                className="form-ctrl-login-custom"
              />
            </InputGroup>
          </Form.Group>
          <div className="sticky-mobile-cta">
            <Button 
              type="submit" 
              className="btn-auth-primary w-100 native-btn" 
              disabled={loading} 
              onClick={() => triggerMediumHaptic()}
            >
              {loading ? (
                <>
                  <Spinner size="sm" animation="border" />
                  <span>SENDING OTP...</span>
                </>
              ) : (
                <>
                  <span>SEND OTP</span>
                  <ArrowRight size={18} />
                </>
              )}
            </Button>
          </div>
        </Form>
      ) : (
        <Form onSubmit={handleOtpLogin}>
          <Form.Group className="mb-4">
            <Form.Label className="text-secondary text-center d-block small mb-3">
              Enter 6-digit code sent to <br /> <strong className="text-white">{identifier}</strong>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="000000"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              className="form-ctrl-login-custom text-center otp-input"
              style={{ letterSpacing: '0.4em', fontSize: '24px', fontWeight: 'bold' }}
              required
              autoFocus
            />
          </Form.Group>
          <div className="sticky-mobile-cta">
            <Button 
              type="submit" 
              className="btn-auth-primary w-100 native-btn" 
              disabled={loading || otp.length < 4} 
              onClick={() => triggerMediumHaptic()}
            >
              {loading ? (
                <>
                  <Spinner size="sm" animation="border" />
                  <span>VERIFYING...</span>
                </>
              ) : (
                <>
                  <span>VERIFY & LOGIN</span>
                  <ArrowRight size={18} />
                </>
              )}
            </Button>
          </div>
          <div className="text-center mt-3">
            <Button 
              variant="link" 
              size="sm" 
              onClick={() => setOtpSent(false)} 
              className="text-secondary small text-decoration-none"
            >
              Change Email/Mobile
            </Button>
          </div>
        </Form>
      )}
    </>
  );
};

export default OtpLoginForm;
